<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import Highcharts from 'highcharts'

const props = defineProps<{ options: Highcharts.Options }>()

const el = ref<HTMLElement | null>(null)
let chart: Highcharts.Chart | null = null

// Shared defaults so analytics charts match the chat's light, compact styling
// without each backend-built config having to repeat them.
const BASE_OPTIONS: Highcharts.Options = {
  credits: { enabled: false },
  accessibility: { enabled: false },
  chart: { backgroundColor: 'transparent', style: { fontFamily: 'inherit' } },
}

function render() {
  if (!el.value) return
  try {
    const merged = Highcharts.merge(BASE_OPTIONS, props.options)
    if (chart) {
      chart.update(merged, true, true)
    } else {
      chart = Highcharts.chart(el.value, merged)
    }
  } catch (e) {
    console.error('[HighchartsChart] failed to render:', e)
  }
}

onMounted(render)
watch(() => props.options, render, { deep: true })
onBeforeUnmount(() => {
  chart?.destroy()
  chart = null
})
</script>

<template>
  <div ref="el" class="highcharts-chat-chart w-full" />
</template>

<style scoped>
.highcharts-chat-chart {
  min-height: 220px;
}
</style>
